import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import Stack from '~/common/components/Stacks/Stack';
import Text from '~/common/components/Texts/Text';

// for formatting the heading labels
export const TopLabel = styled(Typography)(({ theme }) => ({
  borderBottom: '2px solid',
  borderBottomColor: theme.palette.blue[900],
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '1rem',
  height: '20px',
  marginBottom: '1rem',
}));

// for formatting the duo of label and text
export const SpacedRow = styled(Stack)({
  justifyContent: 'space-between',
  width: '100%',
  flexDirection: 'row',
});

// for the group formatting of two or more lines
export const LabelRowGroup = styled(Stack)({
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  marginBottom: '1rem',
  gap: '.25rem',
});

export const LabelText = styled<any>(Text)`
  font-weight: bold;
  padding-right: 0.25rem;
`;

export const StyledDivider = styled(Divider)({
  width: '100%',
});
